export const TERMS_VERSION = '2.0';
export const TERMS_EFFECTIVE_DATE = '18 May 2026';

export const TERMS_OF_SERVICE_CONTENT = {
  title: 'Terms and Conditions',
  companyName: 'Happy Day Limited',
  platforms: ['Meal Manager', 'Activity Planner'],
  domains: ['happyday.care', 'happyday.games'],
  sections: [
    {
      heading: '1. Agreement to Terms',
      paragraphs: [
        'These Terms and Conditions ("Terms") constitute a legally binding agreement between you ("User," "you," or "your") and Happy Day Limited ("Company," "we," "us," "our," or "Happy Day") concerning your access to and use of our apps:',
      ],
      bullets: [
        'Meal Manager – meal planning and scheduling application',
        'Activity Planner – activity management and scheduling application',
        'By accessing or using either app, you agree to be legally bound by these Terms. If you do not agree, you may not access or use the apps.',
      ],
    },
    {
      heading: '2. Access & Security',
      paragraphs: [
        '2.1 Eligibility — Access is restricted to authorized employees of registered care homes. You must be authorized by your care home to access these apps. Access is granted on a per-user basis tied to your employment.',
        '2.2 Login Credentials — CRITICAL: You must not share your login credentials with anyone. You are solely responsible for maintaining the confidentiality of your login credentials. You must not share, loan, or distribute your username, password, or access tokens. All activity on your account is your responsibility. Immediately notify us at dpo@happyday.care if your credentials are compromised. Happy Day Limited will never ask for your password via email or support.',
        '2.3 Account Termination — Your access will be revoked upon: termination of your employment at the care home; termination of your care home\'s account with Happy Day Limited; or violation of these Terms or data protection laws.',
      ],
    },
    {
      heading: '3. Data Handling & Resident Data',
      paragraphs: [
        '3.1 Strict Confidential Handling — You must handle all resident data with strict confidentiality. Resident data includes: resident names and identities; photos and images; health and medical information; dietary restrictions and allergies; personal preferences, hobbies, and interests; and behavioural notes and care requirements.',
      ],
      bullets: [
        'You have obtained proper consent for storing resident data.',
        'You will handle resident data only for legitimate care purposes.',
        'You will not disclose resident data to unauthorized parties.',
        'You understand resident data is confidential and protected.',
      ],
    },
    {
      heading: '3.2 Data Exporting: FORBIDDEN',
      paragraphs: [
        'You are strictly prohibited from exporting resident data. You may NOT export resident data in any form (CSV, Excel, PDF, etc.); download resident data for use outside the apps; share resident data with other systems or organizations; copy or screenshot resident information for external use; or print resident data without explicit authorization.',
        'All resident data must remain within the Activity Planner app environment.',
      ],
    },
    {
      heading: '3.3 Meal Manager: Staff Verification Required',
      paragraphs: [
        'When using Meal Manager, you must verify all ingredients listed in recipes, cooking methods, nutritional information, and allergen information. Community-uploaded recipes and meal plans may contain errors. You are responsible for verification before use.',
      ],
    },
    {
      heading: '4. Limitation of Liability',
      paragraphs: [
        '4.1 Meal Manager — IMPORTANT: The Company is not liable for errors in community-uploaded data. Happy Day Limited does not verify accuracy of ingredients, cooking methods, nutritional claims, allergen information, or compliance with food safety standards. It is YOUR responsibility to verify all community-uploaded meal data before use with residents. To the fullest extent permitted by law, Happy Day Limited shall not be liable for any health incidents, allergic reactions, nutritional deficiencies, or food safety violations arising from community-uploaded recipe or meal data.',
        '4.2 Activity Planner — Happy Day Limited does not provide therapeutic or clinical advice. You are responsible for ensuring activities are appropriate for resident capabilities, safeguarding compliance, and staff supervision. To the fullest extent permitted by law, Happy Day Limited shall not be liable for any injuries or adverse outcomes from activities planned or conducted.',
        '4.3 General Liability Exclusion — To the fullest extent permitted by law, Happy Day Limited, its developers, directors, employees, and affiliates shall not be liable for any indirect, incidental, special, or consequential damages.',
      ],
    },
    {
      heading: '5. Community Conduct & Professional Behavior',
      paragraphs: [
        '5.1 Professional Behavior Required — On the Community Page and all shared forums, all communication must be professional, constructive, and kind. You must respect intellectual property and attribution. You must not engage in harassment or bullying, post inappropriate content, or share confidential information.',
        '5.2 Zero Tolerance Policy — Violations may result in: warning (first offense); content removal (repeated offenses); suspension of community privileges; or permanent account termination (serious violations).',
        '5.3 Content Rights — By posting on the Community Page, you confirm you have the right to share all content you post; content does not infringe third-party rights or privacy; you grant Happy Day Limited permission to display your shared content; and other care homes may view, adapt, and build upon your shared ideas.',
      ],
    },
    {
      heading: '6. System Monitoring & Intellectual Property',
      paragraphs: [
        '6.1 System Usage Monitoring — Happy Day Limited monitors system usage for compliance with these Terms and data protection laws, security and fraud detection, service performance and improvements, and investigation of violations or breaches. Monitoring includes login activity, feature access, and content creation.',
        '6.2 Intellectual Property Protection — The apps, software, database, design, and original content are protected intellectual property of Happy Day Limited.',
      ],
      bullets: [
        'You may NOT: copy or reverse-engineer the app code; redistribute the apps outside your care home; create derivative works; or use the apps for commercial purposes outside your organization.',
        'You MAY: use the apps for your care home\'s operational purposes; share content internally with authorized staff; adapt recipes and activities for your residents\' needs; and print schedules for operational use within your care home.',
      ],
    },
    {
      heading: '7. Changes to These Terms',
      paragraphs: [
        'Happy Day Limited may update these Terms at any time. Continued use of the apps means you accept any updates. We will notify you of major changes via email.',
      ],
    },
    {
      heading: '8. Governing Law',
      paragraphs: [
        'These Terms are governed by English law and UK jurisdiction.',
      ],
    },
    {
      heading: '9. Contact',
      paragraphs: [
        'For questions about these Terms, contact: dpo@happyday.care (response within 5 working days).',
        '© Happy Day Limited. All rights reserved.',
      ],
    },
  ],
  acknowledgements: [
    'I have read and understood the Privacy Policy, Terms and Conditions, Cookies Policy, and Data Processing Agreement.',
    'I will not share my login credentials with anyone and accept responsibility for all activity on my account.',
    'I will handle resident data with strict confidentiality and will not export resident data from Activity Planner.',
    'I will verify all meal and recipe data in Meal Manager before use with residents.',
    'I agree to use both apps professionally and in accordance with these legal agreements.',
  ],
  footer: 'TERMS AND CONDITIONS — HAPPY DAY LIMITED | Meal Manager & Activity Planner | Version 2.0 | happyday.care | happyday.games',
};
